import * as types from "./types";

export const addQuestionnaire = questionnaire => {
  return {
    type: types.ADD_QUESTIONNAIRE,
    payload: questionnaire,
  };
};

export const setQuestionImage = (image, questionnaireId, sIdx, qIdx, iIdx) => {
  return {
    type: types.SET_QUESTION_IMAGE,
    payload: { image, questionnaireId, sIdx, qIdx, iIdx },
  };
};

export const setOptionImage = (image, questionnaireId, sIdx, qIdx, oIdx) => {
  return {
    type: types.SET_OPTION_IMAGE,
    payload: { image, questionnaireId, sIdx, qIdx, oIdx },
  };
};

export const setThankyouImage = (image, key, questionnaireId) => {
  return {
    type: types.SET_THANKYOU_IMAGE,
    payload: { image, key, questionnaireId },
  };
};

export const setSurveyBackground = (background, questionnaireId) => {
  return {
    type: types.SET_SURVEY_BACKGROUND,
    payload: { background, questionnaireId },
  };
};
